import React, { useRef, useEffect } from "react";
import { Card } from "antd";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const { Meta } = Card;
gsap.registerPlugin(ScrollTrigger);

const ServiceCard = ({ title, description, image, index }) => {
    const cardRef = useRef(null);
    const textRef = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        // Card entry animation
        gsap.fromTo(
            cardRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                delay: index * 0.2,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: cardRef.current,
                    start: "top 80%",
                    toggleActions: "play reverse play reverse",

                },
            }
        );

        // Text animation
        gsap.fromTo(
            textRef.current,
            { opacity: 0, x: index % 2 === 0 ? -30 : 30 },
            {
                opacity: 1,
                x: 0,
                duration: 1.2,
                delay: index * 0.3 + 0.2,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: cardRef.current,
                    start: "top 75%",
                    toggleActions: "play reverse play reverse",
                },
            }
        );

        // Image animation
        gsap.fromTo(
            imageRef.current,
            { opacity: 0, scale: 0.9 },
            {
                opacity: 1,
                scale: 1,
                duration: 1.2,
                delay: index * 0.3 + 0.3,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: cardRef.current,
                    start: "top 75%",
                    toggleActions: "play reverse play reverse",
                },
            }
        );
    }, [index]);

    return (
        <div
            ref={cardRef}
            className="w-full sm:w-[90%] md:w-[40%] mx-auto px-2 sm:px-4"
        >
            <Card
                cover={
                    <img
                        ref={imageRef}
                        alt="example"
                        src={image}
                        className="w-full h-48 object-cover rounded-t-lg "
                    />
                }
                className="shadow-lg rounded-lg"
            >
                <Meta
                    title={
                        <span
                            ref={textRef}
                            className=" text-center text-wrap block text-xl md:text-2xl font-bold text-[#031c3f]"
                        >
                            {title}
                        </span>
                    }
                    description={
                        <p className="text-center mt-2 text-sm md:text-base text-gray-800">{description}</p>
                    }
                />
            </Card>
        </div>
    );
};

export default ServiceCard;
